/**
 * Secure Storage – DEPRECATED (Phase 4)
 * Previous implementation used base64 (btoa) as fake "encryption" over localStorage.
 * This is not encryption and Auth tokens must not be stored in localStorage at all
 * (now HttpOnly cookies). This module is retained only for BC and does NOT use
 * localStorage for auth credentials.
 */

const memory = new Map();

export const secureStore = (key, data) => {
    if (process.env.NODE_ENV === 'development') console.warn('secureStore deprecated – auth uses HttpOnly cookies, not localStorage');
    try {
        memory.set(key, data);
        return true;
    } catch {
        return false;
    }
};

export const secureRetrieve = (key) => {
    try {
        return memory.get(key) ?? null;
    } catch {
        return null;
    }
};

export const secureRemove = (key) => {
    try {
        memory.delete(key);
        return true;
    } catch {
        return false;
    }
};

export const secureExists = (key) => {
    try {
        return memory.has(key);
    } catch {
        return false;
    }
};

export default {
    secureStore,
    secureRetrieve,
    secureRemove,
    secureExists,
};
